import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(0.5),
        },
    },
}));

const LabelAdministrado = (props) => {
    const { Estatus } = props;
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Chip
                variant="outlined"
                color={(Estatus) ? "default" : "secondary"}
                label={(Estatus) ? "Interno" : "Externo"}
            />
        </div>
    );
};
export default LabelAdministrado
